import { createContext, useContext } from 'react';

export type AiAssistantChromeValue = {
  isOpen: boolean;
  isPinned: boolean;
};

const AiAssistantChromeContext = createContext<AiAssistantChromeValue>({
  isOpen: false,
  isPinned: false,
});

export function useAiAssistantChrome(): AiAssistantChromeValue {
  return useContext(AiAssistantChromeContext);
}

export const AiAssistantChromeProvider = AiAssistantChromeContext.Provider;
